export const font = {
    ambitThin: 'Ambit-Thin',
    ambitExtraLight: 'Ambit-ExtraLight',
    ambitLight: 'Ambit-Light',
    ambitRegular: 'Ambit-Regular',
    ambitSemiBold: 'Ambit-SemiBold',
    ambitBold: 'Ambit-Bold',
    ambitBlack: 'Ambit-Black',
    // Joko Brand Book fonts: Wallop Sans Semibold for headlines, Instrument Sans for body/CTAs
    wallopSansSemiBold: 'WallopSans-SemiBold',
    instrumentSansMedium: 'InstrumentSans-Medium',
    instrumentSansSemiBold: 'InstrumentSans-SemiBold',
};
